module.exports = __webpack_public_path__ + "static/media/boomea-yellow.35794577.svg";